// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sliders-horizontal.js';

import { paths } from '../generated/sliders-horizontal';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sliders-horizontal', Original, paths);
